var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 74,
    viewBox: "0 0 180 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.547 6.14189C75.1505 5.33765 85.0558 3.5281 90.5587 2.2212C99.2634 0.00952744 102.365 -0.191533 114.571 0.110058C124.877 0.41165 130.78 1.11536 137.083 2.72385C141.786 3.93022 149.69 6.74507 154.593 8.95675C159.495 11.0679 165.999 14.5865 168.9 16.7981C171.702 19.0098 175.504 22.9305 177.205 25.6448C179.906 29.8671 180.206 31.0735 179.906 36.5021C179.706 41.026 178.906 43.6398 176.805 46.7562C175.304 49.0684 170.501 53.7934 166.199 57.2114C161.797 60.73 155.693 65.1533 152.492 67.0634C149.29 68.9735 143.687 71.3862 140.085 72.291C135.082 73.5979 128.979 74 113.571 74C102.565 74 82.3544 73.3968 68.547 72.5926C54.8397 71.7883 40.1319 70.582 36.0297 69.9788C31.9276 69.3756 25.1239 67.8676 21.0218 66.5607C16.9196 65.2538 11.5167 62.6401 9.01537 60.8305C6.51404 58.9204 3.51244 55.804 2.21175 53.8939C0.510844 51.2801 -0.0894748 49.0684 0.0105784 44.444C0.0105784 39.6186 0.610898 37.1053 3.21228 31.8777C5.21334 27.957 8.91531 22.9305 12.6173 19.3114C16.0191 15.9939 20.7216 12.2743 23.1229 11.1684C26.7248 9.35887 30.1266 8.85622 42.0329 8.35356C50.0372 7.95144 61.9435 7.04667 68.547 6.14189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewbg);
export default __webpack_public_path__ + "static/media/newbg.dadcbc2e5b135adabd756ced5b00e835.svg";
export { ForwardRef as ReactComponent };